import { useEffect, useState } from "react";
// import Swiper and modules styles

import useEmblaCarousel from "embla-carousel-react";
import { Video } from "lucide-react";
import { getPublishedEducation } from "../../../services/education.service";
import { ModalComponent } from "../../../ui-components/Modal";

function youtubeId(url: string): string {
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) return u.pathname.replace("/", "");
    if (u.searchParams.get("v")) return String(u.searchParams.get("v"));
    const parts = u.pathname.split("/");
    const idx = parts.findIndex((p) => p === "embed");
    if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
    return "";
  } catch {
    return "";
  }
}

export default function EducationUser() {
  const [items, setItems] = useState<any[]>([]);
  const [active, setActive] = useState<any | null>(null);
  const [watching, setWatching] = useState<any | null>(null);
  const [videoOpen, setVideoOpen] = useState(false);

  useEffect(() => {
    (async () => {
      const data = await getPublishedEducation();
      setItems(Array.isArray(data) ? data : []);
      if (Array.isArray(data) && data.length > 0) {
        const hero =
          data.find(
            (it: any) =>
              Number.isFinite(Number(it.order)) && Number(it.order) === 0
          ) || data[0];
        setActive(hero);
      }
    })();
  }, []);

  const groups = items.reduce((acc: Record<string, any[]>, it: any) => {
    const key = it.category || "Geral";
    acc[key] = acc[key] || [];
    acc[key].push(it);
    return acc;
  }, {} as Record<string, any[]>);
  const heroItem =
    items.find(
      (it) => Number.isFinite(Number(it.order)) && Number(it.order) === 0
    ) || active;
  const categories = Array.from(new Set(Object.keys(groups))).sort((a, b) =>
    a.localeCompare(b)
  );

  const heroId = heroItem ? youtubeId(heroItem.youtube_url) : "";
  const playId = watching ? youtubeId(watching.youtube_url) : heroId;
  const heroThumb = heroItem
    ? `https://img.youtube.com/vi/${heroId}/maxresdefault.jpg`
    : "";

  return (
    <div className="min-h-screen bg-white">
      <div className="md:hidden">
        <div className="w-full rounded-xl overflow-hidden bg-[#182133]">
          <div className="relative">
            {heroThumb ? (
              <img
                src={heroThumb}
                alt={active?.title}
                className="w-full aspect-video object-cover"
              />
            ) : (
              <div className="w-full aspect-video bg-[#1f2530]" />
            )}
            <div className="absolute inset-0 bg-gradient-to-b from-[#24324D]/10 to-[#182133] z-10" />
            {/* <div className="absolute inset-0 bg-gradient-to-r from-[#24324D] via-[#182133] to-transparent z-5" /> */}
          </div>
          <div className="p-3">
            <h1 className="text-lg font-bold tracking-tight text-white">
              {heroItem?.title || "Área Educacional"}
            </h1>
            {heroItem?.description ? (
              <p className="mt-2 text-white/90 text-xs leading-relaxed line-clamp-3">
                {heroItem.description}
              </p>
            ) : null}
            <div className="mt-2 inline-flex items-center gap-2">
              <span className="rounded-full bg-white/10 border border-white/30 px-2.5 py-0.5 text-xs text-white">
                {heroItem?.category || "Geral"}
              </span>
            </div>
            {heroId ? (
              <div className="mt-3 flex items-center gap-2">
                <button
                  className="inline-flex items-center justify-center gap-2 bg-[#24324D] text-white font-semibold px-4 py-2 rounded-md shadow hover:opacity-95 w-full text-sm"
                  onClick={() => {
                    setWatching(heroItem);
                    setVideoOpen(true);
                  }}
                >
                  <span className="text-xs">▶</span>
                  Assistir agora
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="hidden md:block">
        <div className="relative h-[420px] bg-[#000000] rounded-xl overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-[#24324D]/10 to-[#182133] rounded-xl z-10" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#24324D] via-[#182133] to-transparent rounded-xl z-5" />
          {heroThumb && (
            <div className="absolute right-0 bottom-0 h-full w-1/2 rounded-r-xl overflow-hidden z-0">
              <img
                src={heroThumb}
                alt={active?.title}
                className="w-full h-full object-cover"
              />
            </div>
          )}
          <div className="absolute inset-0 flex items-end z-20">
            <div className="px-6 pb-8 w-full">
              <div className="max-w-4xl">
                <h1 className="text-4xl font-bold tracking-tight text-white">
                  {heroItem?.title || "Área Educacional"}
                </h1>
                {heroItem?.description ? (
                  <p className="mt-3 text-white/90 text-lg max-w-3xl line-clamp-3">
                    {heroItem.description}
                  </p>
                ) : null}
                <div className="mt-3 inline-flex items-center gap-2">
                  <span className="rounded-full bg-white/10 border border-white/30 px-3 py-1 text-xs text-white">
                    {heroItem?.category || "Geral"}
                  </span>
                </div>
                {heroId ? (
                  <div className="mt-5 flex items-center gap-3">
                    <button
                      className="inline-flex items-center gap-2 bg-[#24324D] text-white font-semibold px-5 py-2.5 rounded-md shadow hover:opacity-95"
                      onClick={() => {
                        setWatching(heroItem);
                        setVideoOpen(true);
                      }}
                    >
                      <span className="text-sm">▶</span>
                      Assistir agora
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        open={videoOpen}
        handleClose={() => setVideoOpen(false)}
        title={watching?.title || heroItem?.title || "Assistir"}
        autoHeight
        maxWidth={900}
      >
        {playId ? (
          <div style={{ width: "100%" }}>
            <iframe
              style={{ width: "100%", height: 480, borderRadius: 12 }}
              src={`https://www.youtube.com/embed/${playId}?autoplay=1`}
              title={watching?.title || heroItem?.title || "Video"}
              frameBorder={0}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        ) : null}
      </ModalComponent>

      <div className="w-full mt-4 md:mt-8 space-y-4 md:space-y-8">
        {items.length === 0 ? (
          <div className="">
            <div className="flex items-center justify-center flex-col rounded-xl border border-gray-200 bg-gray-50 p-6 text-center">
              <div className="w-14 h-14 rounded-full bg-[#24324D]/10 flex items-center justify-center mb-2">
                <Video className="w-7 h-7 text-[#24324D]" />
              </div>
              <div className="font-semibold text-[#24324D]">
                Nenhum conteúdo educacional disponível
              </div>
              <div className="text-sm text-[#24324D]/70">
                Tente novamente mais tarde.
              </div>
            </div>
          </div>
        ) : (
          categories.map((cat) => {
            const visible = groups[cat]
              .filter((it) => (heroItem ? it.id !== heroItem.id : true))
              .sort((a, b) => {
                const oa = Number.isFinite(Number(a.order))
                  ? Number(a.order)
                  : 0;
                const ob = Number.isFinite(Number(b.order))
                  ? Number(b.order)
                  : 0;
                return oa - ob;
              });
            if (visible.length === 0) return null;
            return (
              <div key={cat}>
                <div className="px-4 md:px-6 flex items-center justify-between mb-2 md:mb-3">
                  <h2 className="text-sm md:text-lg font-semibold text-[#24324D]">
                    {cat}
                  </h2>
                </div>
                <EmblaRow
                  items={visible}
                  onSelect={(it: any) => {
                    setWatching(it);
                    setVideoOpen(true);
                  }}
                />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

function EmblaRow({
  items,
  onSelect,
}: {
  items: any[];
  onSelect: (it: any) => void;
}) {
  const [threshold, setThreshold] = useState(1);
  const options = {
    align: "start",
    dragFree: true,
    containScroll: "trimSnaps",
    inViewThreshold: threshold,
  } as const;
  const [emblaRef] = useEmblaCarousel(options);
  useEffect(() => {
    const mqMd = window.matchMedia("(min-width: 768px)");
    const mqLg = window.matchMedia("(min-width: 1024px)");
    const update = () => {
      if (mqLg.matches) setThreshold(0.5);
      else if (mqMd.matches) setThreshold(0.5);
      else setThreshold(1);
    };
    update();
    mqMd.addEventListener("change", update);
    mqLg.addEventListener("change", update);
    return () => {
      mqMd.removeEventListener("change", update);
      mqLg.removeEventListener("change", update);
    };
  }, []);
  return (
    <div className="px-4 md:px-6">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex gap-3 md:gap-4">
          {items.map((it: any) => {
            const id = youtubeId(it.youtube_url);
            const autoThumb = id
              ? `https://img.youtube.com/vi/${id}/hqdefault.jpg`
              : "";
            const thumb = it.thumbnail_url || autoThumb;
            const progress =
              typeof it.progress === "number" ? it.progress : undefined;
            return (
              <div
                key={it.id}
                className="flex-[0_0_85%] sm:flex-[0_0_50%] md:flex-[0_0_33.333%]"
              >
                <button
                  className="w-full group/card cursor-pointer"
                  onClick={() => onSelect(it)}
                >
                  <div className="relative rounded-lg md:rounded-xl overflow-hidden shadow-md md:shadow-lg mb-2 md:mb-3 bg-black">
                    {thumb ? (
                      <img
                        src={thumb}
                        alt={it.title}
                        className="w-full aspect-video object-cover group-hover/card:scale-105 group-hover/card:opacity-75 transition-all duration-300"
                      />
                    ) : (
                      <div className="w-full aspect-video bg-[#1f2530]" />
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover/card:opacity-100 transition-opacity flex items-center justify-center">
                      <div className="w-12 h-12 md:w-14 md:h-14 bg-white rounded-full flex items-center justify-center group-hover/card:scale-110 transition-transform shadow-2xl">
                        <span className="ml-0.5 text-[#24324D] text-sm md:text-base">
                          ▶
                        </span>
                      </div>
                    </div>
                    {progress !== undefined ? (
                      <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/20">
                        <div
                          className="h-full bg-[#24324D]"
                          style={{
                            width: `${Math.max(0, Math.min(100, progress))}%`,
                          }}
                        />
                      </div>
                    ) : null}
                  </div>
                  <div className="text-left px-1">
                    <div className="text-xs md:text-sm font-bold text-[#24324D] line-clamp-2">
                      {it.title}
                    </div>
                    {it.description ? (
                      <div className="text-[10px] md:text-xs text-[#24324D]/80 mt-0.5 md:mt-1 line-clamp-2">
                        {it.description}
                      </div>
                    ) : null}
                  </div>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
